import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './User/Home/Home'
import Inventory from "./User/Inventory/Inventory";
import InventoryDetail from "./User/InventoryDetail/InventoryDetail";
import Blog from "./User/Blog/Blog";
import BlogSingle from "./User/BlogSingle/BlogSingle";
import About from "./User/About/About";
import FAQ from "./User/FAQ/FAQ";
import TeamList from "./User/TeamList/TeamList";
import NotFound from "./404/NotFound";
import Compare from "./User/Compare/Compare";
import BookTestDrive from "./User/BookTestDrive/BookTestDrive";
import Contact from "./User/Contact/Contact";
import Login from "./Login/Login";
import DashBoard from "./Admin/DashBoard/DashBoard";
import AddListing from "./Admin/AddListing/AddListing";
import Listing from "./Admin/Listing/Listing";
import MyProfile from "./Admin/MyProfile/MyProfile";
import ListingDetail from "./Admin/ListingDetail/ListingDetail";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";


const App = () => {
  return (<>
  
   <Toaster position="top-center" reverseOrder={false}   toastOptions={{
    duration: 900, // 1.5 seconds
  }}
 />
    <BrowserRouter>
         <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home/> } />
        <Route path="/Inventory" element={<Inventory/> } />
        <Route path="/InventoryDetail" element={<InventoryDetail/> } />
        <Route path="/Blog" element={<Blog/> } />
        <Route path="/BlogSingle" element={<BlogSingle/> } />
        <Route path="/About" element={<About/> } />
        <Route path="/FAQ" element={<FAQ/> } />
        <Route path="/TeamList" element={<TeamList/> } />
        {/* <Route path="/Compare" element={<Compare/> } /> */}
        <Route path="/BookTestDrive" element={<BookTestDrive/> } />
        <Route path="/Contact" element={<Contact/> } />
        <Route path="/Login" element={<Login/> } />
        <Route path="/DashBoard" element={<DashBoard/> } />
        <Route path="/AddListing" element={<AddListing/> } />
        <Route path="/Listing" element={<Listing/> } />
        <Route path="/ListingDetail" element={<ListingDetail/> } />
        <Route path="/MyProfile" element={<MyProfile/> } />
        <Route path="*" element={<NotFound/> } />
      </Routes>
    </BrowserRouter>
   </>

  );
};

export default App;
